import { useLocalization } from '@utils/useLocalization';
import dayjs, { type Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Typography, type TypographyProps } from 'hephaestus/web';
import type { ReactElement } from 'react';

dayjs.extend(utc);
dayjs.extend(timezone);

type DateTimeProps = {
  date?: string | Dayjs | Date | null;
  timezone?: string;
} & Omit<TypographyProps, 'children'>;

export const DateTime = ({
  date,
  timezone,
  ...props
}: DateTimeProps): ReactElement | null => {
  const { localizedDateTime } = useLocalization();

  if (!date) {
    return null;
  }

  const dayjsObject = dayjs.isDayjs(date) ? date : dayjs(date);

  return (
    <Typography variant='bodySmall' component='p' {...props}>
      {localizedDateTime(timezone ? dayjsObject.tz(timezone) : dayjsObject)}
    </Typography>
  );
};
